<template>
  <div>
    <div class="lineHeader">
      <div v-if="data.length > 0" class="input-group" id="searchbar">
        <span class="input-group-text" style="color: #5B5B5B;">選擇主辦單位</span>
        <van-dropdown-menu class="dropdown-menu-full">
          <van-dropdown-item
            v-model="selected"
            :options="dropdownOptions"
            :placeholder="'請選擇'"
            @change="ontype"
          />
        </van-dropdown-menu>
      </div>
    </div>
    <b-modal ref="my-lines" size="sm" centered @hide="onHide" id="LineLg" title="Line 登入" hide-header hide-footer>
      <div class="text-center">
        <Linelogin />
      </div>
    </b-modal>
  </div>
</template>

<script>
import Linelogin from "../../auth/Linelogin.vue";
import { mapState, mapActions,mapMutations } from "vuex";
import { DropdownMenu, DropdownItem } from "vant";
export default {
  name: "Linemenubar",
  components: {
    Linelogin,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,   
  },
  props: {
    data: Array,
  },
  data() {
    return {    
      show: null,
      selected:null,
      dropdownOptions: [], // 初始化為空陣列
    };
  }, 
  watch: {
    data(newVal) {
      if (newVal.length > 0) {
        this.dropdownOptions = [
          { text: '請選擇', value: null },
          ...newVal
            .filter((item) => item.name !== 'admin')
            .map((item) => ({
              text: item.name,
              value: item.id,
            })),
        ];
      }
    },
  },  
  methods: {
    ...mapActions("account", ["checktoken", "reLogin"]),
    ...mapMutations("account", ["setpage"]),    

    showline() {
      this.$refs["my-lines"].show();      
    },

    closeline() {
      this.$refs["my-lines"].hide();      
    },    
 
    onHide(evt) {
          if(evt.trigger === "backdrop"){
              evt.preventDefault();
          }
      },
    ontype(){      
      let temp =  this.data.filter(rs => rs.id ==this.selected)
      if(temp.length==0 || temp==null){
        temp = [{id:0}]
      }
      this.$emit("ontype",temp)
    },
    ReLogin() {   
      let obj = { id: "Lineorg" };
      this.setpage(obj) 
      this.reLogin(); 
      this.$emit("reget")
    },    
   
  },

  mounted() {
    if (this.data.length > 0) {
      this.dropdownOptions = [
        { text: '請選擇', value: null },
        ...this.data
          .filter((item) => item.name !== 'admin')
          .map((item) => ({
            text: item.name,
            value: item.id,
          })),
      ];
    }
  },  
  

  computed: {
    ...mapState("account", ["status", "user"]),
  },
};
</script>
<style scoped>
/* Header */
.lineHeader {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 7;
  width: 100%;
  height: 3.5rem;
  padding: 0.5rem;
  background-color: #f3f3f5;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}


.input-group-text {
  font-size: 0.9rem;
  color: #535252;
  background-color: transparent;
  border: none;
}

.form-select {
  flex: 1;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #ffffff;
}

/* Searchbar */
#searchbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%; /* 確保整個區塊滿版 */
  margin: 0 auto;
}

.input-group-text {
  font-size: 0.9rem;
  color: #ffffff;
  background-color: transparent;
  border: none;
  white-space: nowrap; /* 防止文字換行 */
}

.dropdown-menu-full {
  flex: 1; /* 讓 DropdownMenu 自動填滿剩餘空間 */
  width: 100%; /* 確保寬度滿版 */
}

.van-dropdown-menu {
  width: 100%; /* 確保 DropdownMenu 滿版寬度 */
}

.van-dropdown-item {
  width: 100%; /* 確保 DropdownItem 滿版寬度 */
}
</style>
<style>
/* Modal */
#LineLg > .modal-dialog > .modal-content > .modal-body {
  border-color: transparent;
  background-color: transparent !important;
  color: white;
} 
#LineLg > .modal-dialog > .modal-content {
  border-color: transparent;  
  background-color: transparent !important;
}
.modal-backdrop{ 
  background-color: #f3f0f0 !important;
  opacity: 0.95 !important; /* 0.95 越大越黑，可自行調整 */
}
</style>